import React from 'react';
// import { Image } from 'react-bootstrap';
// import LocationImage from '../icons/place';
// import PhoneImage from '../icons/phone';
// import ProfilePage from '../pages/profile';
// import LetterImage from '../icons/letter';
import { useParams } from 'react-router-dom';
//import useApi from '../../hooks/useApi';
import { API_BASE_URL } from '../../constants';
import Loader from '../loader';
import useSingleVerkstedsInfo from '../../hooks/singleVerkstedsInfo';
import AdminLayoutTest from '../adminVerkstedOversiktsTest';

function AdminVerkstedOversikt() {

    const { id } = useParams();
    const url = `${API_BASE_URL}/users/${id}?populate=*`;
    const {verksted, isLoading, isError} = useSingleVerkstedsInfo(url);
    console.log(url);
    console.log(verksted);

    // const {username, telephone, address, email, image} = verksted;

    if(isLoading || !verksted) {
        return(
            <Loader />
        )
    }
    if(isError) {
        return(
            <div>Oida, her har det gått noe galt! Vennligst prøv å laste inn siden på nytt!</div>
        )
    }

    return (
        <AdminLayoutTest
            verksted={verksted}
        />
    )
}

export default AdminVerkstedOversikt;